module.exports = __webpack_public_path__ + "img/republic-of-the-congo.e2600f73.png";